import React from "react";

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_56ae7323-5fde-47d2-aaef-037899d4e104/artifacts/v2heysoi_1769273488975.mp4";
const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_cornwall-movers/artifacts/c5to8wjs_1769061921315.png";

const VideoHero = ({ 
  title, 
  subtitle, 
  children,
  className = "",
  minHeight = "min-h-[40vh]"
}) => {
  return (
    <section className={`relative ${minHeight} flex items-center ${className}`}>
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          poster={HERO_IMAGE}
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0047AB]/95 via-[#0047AB]/85 to-[#003380]/75"></div>
      </div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold font-['Barlow_Condensed'] text-white uppercase mb-6">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default VideoHero;
